import React, { Component } from "react";
import { Modal } from "react-bootstrap";

import "../../../payrollsetup/systemlevel/deductionsetup/DeductionStyles.css";
import { withRouter } from "react-router-dom";
import AddEarningGeneralLedger from "./AddEarningGeneralLedger";

class GeneralLedgerEarningsDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };

    this.onOpenAddModal = this.onOpenAddModal.bind(this); //modal
    this.onCloseAddModal = this.onCloseAddModal.bind(this); //modal
  }

  onOpenAddModal() {
    this.setState({ open: true });
  }

  onCloseAddModal() {
    this.setState({ open: false });
  }

  onClickActivityHistory = () => {
    this.props.onClickActivityHistoryButton(() =>
      this.props.history.push("/gl-account-earnings-activity-history")
    );
  };

  render() {
    const Id = this.props.Id;
    const showHistoryButton = this.props.showHistoryButton;
    return (
      <div id="deduction-page-header-container">
        <div className="pageTitle-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            id={Id.pageTitle}
            className="pageTitle col-lg-7 col-md-6 col-sm-8 col-xs-12"
          >
            Map General Ledger Accounts - Earnings
          </div>

          <div className="nc-navigation-button-family hidden-sm hidden-xs col-lg-5 col-md-6 col-sm-12 col-xs-12">
            {showHistoryButton && (
              <button
                id={Id.historyButton}
                className="nc-button outline-button"
                onClick={this.onClickActivityHistory}
              >
                <i className="fa fa-history" aria-hidden="true" /> HISTORY
              </button>
            )}

            <button
              id={Id.addButton}
              type="button"
              className="nc-button primary-button pull-right"
              onClick={this.onOpenAddModal}
            >
              <i className="fa fa-plus"> </i>
              ADD GL ACCOUNT
            </button>
            <Modal
              bsClass="entity-page-add-modal-sm modal"
              id="gl-popup-modal"
              backdrop={"static"}
              keyboard={false}
              animation={false}
              show={this.state.open}
              onHide={this.onCloseAddModal}
            >
              <Modal.Header style={{ borderBottom: "none" }}>
                <div className="close-icon col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <i
                    id={Id.modalCloseIcon}
                    onClick={this.onCloseAddModal}
                    className="fa fa-times-circle-o fa-lg"
                  />
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="modal-row">
                  <AddEarningGeneralLedger
                    onPopOverCancel={() => this.onCloseAddModal()}
                  />
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div className="deduction-page-description-container">
          <div
            id="deduction-page-description"
            className="deduction-page-description-content col-lg-7 col-md-7 col-sm-12 col-xs-12"
          >
            <p id={Id.pageDescription}>
              Earnings expenses can be grouped together on the General Ledger
              Transactions report by associating them with base general ledger
              accounts. Map each of the earnings below to a corresponding
              expense account.
            </p>
          </div>

          <div className="deduction-page-description-button col-lg-5 col-md-5 col-sm-12 col-xs-12">
            <div className="nc-navigation-button-family col-xs-12 hidden-lg hidden-md">
              <div className="primary-group">
                <button
                  id="add-deduction-button"
                  type="button"
                  className="nc-button primary-button"
                  onClick={this.onOpenAddModal}
                >
                  <i className="fa fa-plus" />
                  <span className="hidden-lg hidden-md ">
                    &nbsp; ADD GL ACCOUNT
                  </span>
                </button>
              </div>
              {showHistoryButton && (
                <div className="secondary-group">
                  <button
                    id="map-gl-accounts-activity-history-earnings-button"
                    className="nc-button outline-fa-button"
                    onClick={this.onClickActivityHistory}
                  >
                    <i className="fa fa-history" aria-hidden="true" />
                    <span className="hidden-lg hidden-md hidden-xs">
                      &nbsp; HISTORY
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(GeneralLedgerEarningsDescription);
